/* eslint-disable */
!function(){function e(e,n){n=n||{bubbles:!1,cancelable:!1,composed:!1};const t=document.createEvent("Event");return t.initEvent(e,n.bubbles,n.cancelable,n.detail),t}typeof window.Event!=="function"&&(e.prototype=window.Event.prototype,window.Event=e)}();
/* eslint-enable */
